import constants from '../constants.js';

/* Property Definitions */
const LogTime = {
  display: 'Log Time',
  dataAt: 'LogTime',
  disabled:  true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const Email = {
  displayName: "Email",
  dataAt: "Email", 
  disabled: true, 
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  hideIfEmpty: true
};

const DebtorIdentifier = {
  displayName: "Debtor",
  dataAt: "DebtorIdentifier", 
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  hideIfEmpty: true
};

 const Pnr = {
  displayName: "PNR",
  dataAt: "Pnr", 
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  hideIfEmpty: true
 };

 const ProfileName = {
  displayName: "Profile",
  dataAt: "ProfileName", 
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  hideIfEmpty: true
 };

 const Firstname = {
   displayName: "First Name",
   dataAt: "Firstname",
   disabled: true,
   displayAs: constants.DISPLAY_AS.TEXT_INPUT,
   hideIfEmpty: true
 };

 const Lastname = {
  displayName: "Last Name",
  dataAt: "Lastname",
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  hideIfEmpty: true
};

const CreatedOn = {
  displayName: 'Created on',
  dataAt: 'CreatedOn',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CreatedBy = {
  displayName: 'Created by',
  dataAt: 'CreatedBy',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const Id = {
  displayName: 'Identifier',
  dataAt: 'Id',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const LogType = {
  displayName: 'Type',
  dataAt: 'LogType',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
  required: false
};

const LogLevel = {
  displayName: 'Type',
  dataAt: 'LogLevel',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
  required: false
};

const RoleName = {
  displayName: 'Application',
  dataAt: 'RoleName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
  required: false
};

const LogMessage = {
  displayName: 'Log Message',
  dataAt: 'LogMessage',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_AREA
};

const ModifiedOn = {
  displayName: 'Modified on',
  dataAt: 'ModifiedOn',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ModifiedBy = {
  displayName: 'Modified by',
  dataAt: 'ModifiedBy',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

// Choose what properties display in the Admin page
const AdminPanel = {
  tabName: 'Admin',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [CreatedBy, CreatedOn, ModifiedBy, ModifiedOn]
};

// lbaViewGrid attributes. This is also where you define which columns appear in the ViewGrid.
const LogsList = {
  rootNode: true,
  displayName: 'AppInsights Logs',
  endpoint: 'Logs',
  iconClass: 'fa-hammer',
  displayAs: constants.DISPLAY_AS.VIEW_GRID,
  canCopyItem: false,
  canAddNew: false,
  children: [LogMessage],
  gridCols:
    [
      {name: 'Type', key: 'LogLevel'},
      {name: 'Email', key: 'Email'},
      {name: 'DebtorIdentifier', key: 'DebtorIdentifier'},
      {name: 'Log Time', key: 'LogTime'}
    ]
};

const LogResource = {
  rootNode: true,
  displayName: "AppInsights Logs",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  iconClass: "fa-cog",
  dataAt: "",
  children: [LogsList],
  endpoint: "Logs",
};

export default {
  LogResource,
  LogsList,
  AdminPanel,
  Id,
  CreatedBy,
  CreatedOn,
  ModifiedBy,
  ModifiedOn,
  LogType,
  RoleName,
  LogLevel,
  LogMessage,
  Email,
  DebtorIdentifier,
  LogTime, 
  Pnr,
  ProfileName,
  Firstname,
  Lastname
}



// WEBPACK FOOTER //
// ./src/config/fields/logs.js